import React, { useEffect, useState } from "react";
import ModalCustom from "../../../../components/modal/ModalCustom";
import { Grid } from "@mui/material";
import {
  ButtonOutlined,
  ButtonPrimary,
} from "../../../../components/button/ButtonCustoms";
import InputTextField from "../../../../components/input/inputTextField";
import UploadFile from "../../../../components/upload/UploadFile";

type FileType = File[] | null;
type ModalFormSendRequestProps = {
  isOpenModal: boolean;
  setIsOpenModal: (isOpen: boolean) => void;
  action: string;
  file: any;
  setFile: (file: any) => void;
  inputValue: any;
  setInputValue: (value: any) => void;
  onSend?: () => void;
  errorMessage: any;
};

const ModalFormSendRequest: React.FC<ModalFormSendRequestProps> = ({
  isOpenModal,
  setIsOpenModal,
  action,
  file,
  setFile,
  inputValue,
  setInputValue,
  onSend,
  errorMessage,
}) => {
  const [isCanEdit, setIsCanEdit] = useState<boolean>(false);
  const [isValudateFile, setIsValudateFile] = useState(false);
  // const [file, setFile] = useState(null);

  // const [formSendRequest, setFormSendRequest] = useState<{
  //   title: string;
  //   detail: string;
  // }>({
  //   title: "",
  //   detail: "",
  // });

  const handleChangeValue = (name: string, value: any) => {
    setInputValue((prev: any) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  useEffect(() => {
    if (action === "create") {
      setIsCanEdit(true);
    } else {
      setIsCanEdit(false);
    }
  }, [action]);

  return (
    <ModalCustom
      title={action === "create" ? "ส่งคำร้องขอ" : "แก้ไขเพิ่มเอกสาร"}
      subTitle="กรุณาระบุข้อมูลให้ครบถ้วนก่อนการยืนยัน"
      open={isOpenModal}
      onClose={() => {
        setIsOpenModal(false);
      }}
      component={
        <Grid container spacing={2}>
          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            sx={{
              alignSelf: "end",
            }}
          >
            <InputTextField
              heading={"ชื่อวิทยานิพนธ์"}
              placeholder={"ชื่อวิทยานิพนธ์"}
              value={inputValue.advisor_request_name ?? ""}
              onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                handleChangeValue("advisor_request_name", e.target.value);
              }}
              disabled={!isCanEdit}
              helperText={
                errorMessage.includes("advisor_request_name")
                  ? "Name of thesis is required."
                  : ""
              }
              required
            />
          </Grid>

          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            sx={{
              alignSelf: "end",
            }}
          >
            <InputTextField
              heading={"รายละเอียด"}
              placeholder={"รายละเอียด"}
              value={inputValue.advisor_request_desc ?? ""}
              onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                handleChangeValue("advisor_request_desc", e.target.value);
              }}
              disabled={!isCanEdit}
              row={3}
              maxRows={5}
              disablePaddingMultiline
              multiline
              inputHeight={"auto"}
              helperText={
                errorMessage.includes("advisor_request_desc")
                  ? "Detail is required."
                  : ""
              }
              required
            />
          </Grid>

          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            sx={{
              alignSelf: "end",
            }}
          >
            <UploadFile
              onDrop={(file) => {
                setFile(file);
              }}
              file={file}
              onDeleteFile={() => {
                setFile(null);
              }}
              noClick={false}
              // customFormat={["image/jpeg", "image/jpg", "image/png"]}
              helperText={
                errorMessage.includes("file") ? "File is required." : ""
              }
              required
            />
          </Grid>

          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <ButtonOutlined
              onClick={() => {
                setIsOpenModal(false);
                if (action !== "create") {
                  setIsCanEdit(false);
                }
              }}
              mode="del"
              buttonName="ยกเลิก"
              btnProps={{
                width: "125px",
                margin: "12px",
              }}
            />

            {isCanEdit && (
              <ButtonPrimary
                onClick={() => {
                  onSend && onSend();
                }}
                buttonName={"บันทึก"}
                btnProps={{
                  width: "125px",
                  margin: "12px",
                }}
                mode="next"
              />
            )}

            {!isCanEdit && (
              <ButtonPrimary
                onClick={() => {
                  setIsCanEdit(true);
                }}
                buttonName={"แก้ไข"}
                btnProps={{
                  width: "125px",
                  margin: "12px",
                }}
              />
            )}

            {!isCanEdit && (
              <ButtonPrimary
                onClick={() => {}}
                mode="del"
                buttonName={"ลบ"}
                btnProps={{
                  width: "125px",
                  margin: "12px",
                }}
              />
            )}
          </Grid>
        </Grid>
      }
    />
  );
};

export default ModalFormSendRequest;
